import React, { useEffect, useState } from 'react';
import { Box, Button, MenuItem, TextField, useTheme } from '@mui/material';
import { FaFilter } from 'react-icons/fa';
import { Grid } from "@material-ui/core";
import useGlobalContext from "../../Hooks/useGlobalContext";
import getInitialDataFilter from "./initialDataFilter";
import { IFilter } from "./types";

const primaryColor = '#1c2e4a';

const ProductPageFilter: React.FC = () => {
    const theme = useTheme();

    const { filters, setFilters, showFilters, setShowFilters } = useGlobalContext();
    
    const [ncm, setNcm] = useState<string>(filters?.ncm || '');
    const [barcode, setBarcode] = useState<string>(filters?.barcode || '');
    const [descricao_completa, setDescricaoCompleta] = useState<string>(filters?.descricao_completa || '');

    const [loading, setLoading] = useState(false);

    const runFilters = () => {
        if (setFilters) {
            setFilters((prev) => ({
                ...prev,
                establishment: '',
                ncm: ncm || '',
                barcode: barcode || '',
                descricao_completa: descricao_completa || ''
            }));
        }
    };

    const clearFilters = () => {
        if (setFilters) {
            setFilters(getInitialDataFilter());
        }
        setNcm('');
        setBarcode('');
        setDescricaoCompleta('');
    }

    useEffect(() => {
        if (filters?.ncm) {
            setNcm(filters.ncm);
        }
        if (filters?.barcode) {
            setBarcode(filters.barcode);
        }
        if (filters?.descricao_completa) {
            setDescricaoCompleta(filters.descricao_completa);
        }
    }, [filters]);

    return (
        <Grid item xs={12} md={12} lg={12}>
            <Box sx={{ backgroundColor: theme.palette.background.paper }} p={1}>
                <Grid item xs={12}>
                    <Button onClick={() => {
                        if (setShowFilters) {
                            setShowFilters((n: boolean) => !n)
                        }
                    }}>
                        <span style={{ marginRight: '10px' }}>
                            <FaFilter />
                        </span>
                        {showFilters ? 'Esconder Filtros' : 'Mostrar Filtros'}
                    </Button>
                </Grid>
                {showFilters && (
                    <Grid item xs={12} style={{ marginTop: 2 }} component="section">
                        <Grid container spacing={2} style={{ maxWidth: '100%' }}>
                            <Grid item xs={12} sm={4} md={4} lg={4}>
                                <TextField
                                    label="NCM"
                                    disabled={loading}
                                    variant="outlined"
                                    value={ncm}
                                    onChange={e => setNcm(e.target.value)}
                                    onClick={() => setNcm('')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4}>
                                <TextField
                                    label="CÓDIGO DE BARRAS"
                                    disabled={loading}
                                    variant="outlined"
                                    value={barcode}
                                    onChange={e => setBarcode(e.target.value)}
                                    onClick={() => setBarcode('')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4}>
                                <TextField
                                    label="DESCRIÇÃO"
                                    disabled={loading}
                                    variant="outlined"
                                    value={descricao_completa}
                                    onChange={e => setDescricaoCompleta(e.target.value)}
                                    onClick={() => setDescricaoCompleta('')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={6} style={{ marginBottom: 2 }}>
                                <Button
                                    sx={{
                                        borderRadius: '0px',
                                        border: '1px solid',
                                        margin: '0',
                                        width: '100%'
                                    }}
                                    disabled={loading}
                                    onClick={clearFilters}
                                >
                                    Limpar filtros
                                </Button>
                            </Grid>
                            <Grid item xs={6} style={{ marginBottom: 2 }}>
                                <Button
                                    sx={{
                                        borderRadius: '0px',
                                        border: '1px solid #1c2e4a',
                                        margin: '0',
                                        backgroundColor: primaryColor,
                                        color: 'white',
                                        width: '100%'
                                    }}
                                    disabled={loading}
                                    onClick={runFilters}
                                >
                                    Filtrar
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Box>
        </Grid>
    );
}

export default ProductPageFilter;
